import { render } from "./PagenationUi2.vue?vue&type=template&id=142ed6c5"
import script from "./PagenationUi2.vue?vue&type=script&lang=js"
export * from "./PagenationUi2.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__